import { ComponentChildren } from 'preact'

interface HeadingProps {
  title: ComponentChildren
  subtitle: ComponentChildren
}

export function Heading({ title, subtitle }: HeadingProps) {
  return (
    <>
      <h2 className="text-2.5xl font-normal pr-10 sm:pr-0 leading-snug max-w-lg md:text-4xl md:leading-[1.4]">
        {title}
      </h2>
      <p className="max-w-lg mt-6 text-sm">{subtitle}</p>
    </>
  )
}
